export function shortenAddress(address?: string, length = 4, ends = 4) {
  // console.log(address);
  if (!address) {
    return "";
  }
  return `${address.slice(0, 2 + length)}..${address.slice(
    -ends
  )}`.toLowerCase();
}
